import { useEffect } from "react";
import { MessageCircle, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import PageHero from "@/components/common/PageHero";
import InquiryForm from "@/components/forms/InquiryForm";
import { companyInfo } from "@/data/siteContent";

const ContactPage = () => {
  useEffect(() => {
    document.title = "Contact Us | Keshavlal & Company";
  }, []);

  return (
    <div data-testid="contact-page-root">
      <PageHero
        eyebrow="Contact"
        title="Share Your Requirement and Get a Corporate Quote"
        description="For bulk umbrellas, corporate branding umbrellas, and product category supply discussions."
        testId="contact-page-hero"
      />

      <section className="bg-slate-50" data-testid="contact-main-section">
        <div className="mx-auto grid w-full max-w-7xl gap-8 px-4 py-14 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:px-8">
          <div className="space-y-4" data-testid="contact-information-column">
            <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="contact-info-card">
              <h2 className="text-2xl font-semibold text-slate-900" data-testid="contact-info-title">
                Contact Information
              </h2>
              <div className="mt-4 space-y-3 text-sm text-slate-700" data-testid="contact-info-details">
                <p data-testid="contact-info-phone">Phone: {companyInfo.phoneDisplay}</p>
                <p data-testid="contact-info-email">Email: {companyInfo.email}</p>
                <p data-testid="contact-info-address">Address: {companyInfo.address}</p>
              </div>
              <div className="mt-5 flex flex-wrap gap-3" data-testid="contact-info-action-buttons">
                <Button
                  asChild
                  variant="outline"
                  className="rounded-full border-slate-300"
                  data-testid="contact-call-button"
                >
                  <a href={`tel:${companyInfo.phoneLink}`} data-testid="contact-call-link">
                    <PhoneCall className="mr-2 h-4 w-4" /> Call Us
                  </a>
                </Button>
                <Button
                  asChild
                  className="rounded-full bg-emerald-600 text-white hover:bg-emerald-700"
                  data-testid="contact-whatsapp-button"
                >
                  <a href={companyInfo.whatsappLink} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-link">
                    <MessageCircle className="mr-2 h-4 w-4" /> WhatsApp
                  </a>
                </Button>
              </div>
            </div>

            <div
              className="overflow-hidden rounded-2xl border border-slate-200 bg-white"
              data-testid="contact-map-placeholder-card"
            >
              <div className="aspect-[16/9] w-full" data-testid="contact-map-placeholder">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.675653072696!2d74.833149374545!3d12.864213517224659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba35bcd6a1cd3ab%3A0x6d10b0fdc45feec1!2sKeshavlal%20and%20Company!5e0!3m2!1sen!2sin!4v1774503948485!5m2!1sen!2sin"
                  className="h-full w-full border-0"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Keshavlal and Company Location"
                  data-testid="contact-map-iframe"
                />
              </div>
              <div className="border-t border-slate-200 px-5 py-4 text-sm text-slate-600" data-testid="contact-map-placeholder-text">
                <a
                  href={companyInfo.mapLink}
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-orange-600 hover:text-orange-700"
                  data-testid="contact-map-get-directions-link"
                >
                  Get directions on Google Maps
                </a>
              </div>
            </div>
          </div>

          <div data-testid="contact-form-column">
            <InquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;